export function isVisible(el) {
    return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}